import React from 'react';

const ChangePassword =  ({currentpasswrod ,password ,repassword,unequalpassword ,onUpdateInfoChange ,onUpdatePasswordClick,staffManagement,oldpassworderror}) =>{
    return(
        <div className="changepassword">
            <div className="title">Change password</div>
              <div className="input">
                <label className="label">current Password</label>
                <input type="password" defaultValue={currentpasswrod} onChange={e=>onUpdateInfoChange(e,'currentpasswrod')} maxlength="100"/>
              </div>
              {oldpassworderror &&
              <div className="error-message">current password can't be empty </div>
              }
              <div className="input">
                <label className="label">New Password</label>
                <input type="password" defaultValue={password} onChange={e=>onUpdateInfoChange(e,'password')} maxlength="100"/>
              </div>
              <div className="input">
                <label className="label">Confirm New Password</label>
                <input type="password" defaultValue={repassword} onChange={e=>onUpdateInfoChange(e,'repassword')} maxlength="100"/>
              </div>
              {unequalpassword && 
              <div className="error-message">New Password and Confirm Password doesn't match</div>
              }
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={onUpdatePasswordClick} disabled={staffManagement.updatingpassword || oldpassworderror || unequalpassword}>
                    {staffManagement.updatingpassword?'UPDATING...':'UPDATE'}
                    </button>
              </div>
        </div>
    )
}

export default ChangePassword;